var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('p',[_vm._v(_vm._s(_vm.messageBody))])]),_vm._v(" "),_c('div',{attrs:{"text-center":""}},[_c('a',{staticClass:"btn btn-primary",on:{"click":_vm.onConfirmClick}},[_vm._v(_vm._s(_vm.i18n.app.common.close))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }